import {
  faBrakeWarning,
  faCircleCheck,
  faDiamondExclamation,
  faHeadSideBrain,
  faInfoCircle as faInfoCircleDuotone,
  faTrash,
} from '@fortawesome/duotone-regular-svg-icons';
import {
  faBolt,
  faCamera,
  faFlag,
  faPlus,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { faDiamondExclamation as newConditionIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGlobalIcons } from 'lib-node-question-builder';

export const questionBuilderIcons: ReturnType<typeof useGlobalIcons> = {
  success: () => <FontAwesomeIcon icon={faCircleCheck} />,
  error: () => <FontAwesomeIcon icon={faBrakeWarning} />,
  warning: () => <FontAwesomeIcon icon={faDiamondExclamation} />,
  infoAlert: () => <FontAwesomeIcon icon={faHeadSideBrain} />,
  manualReview: () => <FontAwesomeIcon icon={faFlag} />,
  newCondition: () => <FontAwesomeIcon icon={newConditionIcon} />,
  hidden: () => <FontAwesomeIcon icon={faEyeSlash} />,
  visible: () => <FontAwesomeIcon icon={faEye} />,
  toolTip: () => <FontAwesomeIcon icon={faInfoCircleDuotone} />,
  addButtonIcon: () => <FontAwesomeIcon icon={faPlus} />,
  trashCan: () => <FontAwesomeIcon icon={faTrash} />,
  snapshot: () => <FontAwesomeIcon icon={faCamera} />,
  boltAnswer: () => <FontAwesomeIcon icon={faBolt} />,
  userAnswer: () => <FontAwesomeIcon icon={faUser} />,
  automation: () => (
    <img
      style={{ scale: '200%' }}
      src="/images/ai-answered.svg"
      alt="AI Answered"
    />
  ),
};
